export default __webpack_public_path__ + "static/media/close.c0c25c59.svg";